/** sessionStorage key set before forced Auth0 logout */
export const AUTH_SESSION_LOGOUT_REASON_KEY = "wa_auth_session_logout_reason";

/**
 * Auth errors that mean the browser Auth0 session cannot be used against this API.
 * Force a clean logout + re-login rather than leaving the user on the error boundary.
 *
 * - USER_NOT_FOUND: valid Auth0 session but no matching user in this environment's DB
 * - INVALID_TOKEN / EXPIRED_TOKEN: Auth0 SPA still has a user object, but the access
 *   token (or refresh) is rejected by the API. Password changes and long-lived
 *   refresh-token rotation commonly surface this way.
 */
export const AUTH_SESSION_FORCE_LOGOUT_CODES = [
  "USER_NOT_FOUND",
  "INVALID_TOKEN",
  "EXPIRED_TOKEN",
] as const;

export type AuthSessionLogoutReason =
  (typeof AUTH_SESSION_FORCE_LOGOUT_CODES)[number];

/** @deprecated Prefer AUTH_SESSION_FORCE_LOGOUT_CODES — kept for existing imports */
export const AUTH_SESSION_FORCE_LOGOUT_CODE =
  "USER_NOT_FOUND" as AuthSessionLogoutReason;
